import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal/modal.component';
import { CouponModalComponent } from './coupon/coupon-modal.component';


@NgModule({
  declarations: [ModalComponent, CouponModalComponent],
  exports: [ModalComponent, CouponModalComponent],
  imports: [
    CommonModule
  ]
})
export class ModalModule { }
